<template>
  <footer class="beian-footer">
    <a
      class="beian-link"
      href="https://beian.mps.gov.cn/#/query/webSearch?code=13102402000556"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img class="beian-badge" src="/beian-ghs.png" alt="公安备案徽标" />
      <span>冀公网安备13102402000556号</span>
    </a>
    <span class="beian-divider">|</span>
    <a
      class="beian-link"
      href="https://beian.miit.gov.cn/"
      target="_blank"
      rel="noopener noreferrer"
    >冀ICP备2026040145号-1</a>
  </footer>
</template>

<script>
export default {
  name: 'BeianFooter',
}
</script>

<style scoped>
.beian-footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 6px 0;
  background: #f5f7fa;
  border-top: 1px solid #e4e7ed;
  font-size: 12px;
  color: #909399;
  user-select: none;
}
.beian-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #909399;
  text-decoration: none;
}
.beian-link:hover {
  color: #409eff;
}
.beian-badge {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.beian-divider {
  color: #dcdfe6;
}
</style>
